import React, { FC } from 'react';
import { ThreeWLAItem } from '../item';
import { Spinner, SpinnerSize, Box } from '@bechtel/gds';
import { map } from 'lodash';
import { CrewListContainerStyled, CrewListItemStyled, CrewBulletStyled, ErrorContainer } from './styled';
import { UNIT_OF_MEASURE } from '../types';
import { CrewMember } from '@bechtel/types';
import { AppUser, ErrorRetry, StatsSpinner } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';

interface CrewTreeProps {
  result: any;
  unitOfMeasure: UNIT_OF_MEASURE;
  selectedCrewMember: CrewMember | null;
  depth: number;
  selectedGeneralForeman?: CrewMember | null;
  selectedSuperintendent?: CrewMember | null;
  user: AppUser | null;
}
export const CrewTree: FC<CrewTreeProps> = ({
  result,
  unitOfMeasure,
  selectedCrewMember,
  depth,
  selectedGeneralForeman,
  selectedSuperintendent,
  user,
}) => {
  const { loading, error, data, refetch } = result;
  return (
    <>
      {loading &&
        (depth != 0 ? (
          <Spinner size={SpinnerSize.MEDIUM} data-testid="initial-load-spinner"></Spinner>
        ) : (
          <Box
            alignItems={{ sm: 'center' }}
            justifyContent={{ sm: 'center' }}
            py={{ sm: '900' }}
            flexGrow={{ sm: 1 }}
            data-testid="drilldown-dot-spinner"
          >
            <StatsSpinner />
          </Box>
        ))}
      {!loading && error && (
        <ErrorContainer>
          <ErrorRetry refetch={refetch}>
            <Trans>There was error loading data for Three-Week Look Ahead.</Trans>
          </ErrorRetry>
        </ErrorContainer>
      )}
      {!loading &&
        !error &&
        data &&
        data.weeklyLookAheadStatsByPersona &&
        data.weeklyLookAheadStatsByPersona.length > 0 && (
          <CrewListContainerStyled>
            {map(data.weeklyLookAheadStatsByPersona, (stat) => {
              return (
                <CrewListItemStyled key={stat.crewMember.id}>
                  {depth != 0 && <CrewBulletStyled data-testid="crew-bullet" />}
                  {/* No need for bullet at the root */}
                  <ThreeWLAItem
                    personaType={stat.crewMember.persona}
                    threeWeekLookAheadStat={stat}
                    unitOfMeasure={unitOfMeasure}
                    selectedCrewMember={selectedCrewMember}
                    selectedSuperintendent={selectedSuperintendent}
                    selectedGeneralForeman={selectedGeneralForeman}
                    depth={depth}
                    user={user}
                  />
                </CrewListItemStyled>
              );
            })}
          </CrewListContainerStyled>
        )}
    </>
  );
};
